/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Ladda ned Bumble",
      "Acceptera alla",
      "Se alternativ",
      "Cookiepolicy",
      "Gå tillbaka",
      "Felaktigt telefonnummer",
      "© {{current_year}} Bumble Alla rättigheter reserverade",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Om",
      "Ambassadörer",
      "The Buzz",
      "Vi använder cookies. Om du inte är OK med det kan du göra ändringar i dina inställningar.",
      "Ladda ner appen",
      "Ladda ner för Android",
      "Ladda ner för iOS",
      "Sorry, vi hittar tyvärr inte sidan du letar efter.",
      "Logga in",
      "Gå med",
      "Bumbla med oss!",
      "Hoppsan, något gick fel..."
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagar",
                  "dagars"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timmar",
                  "timmars"
            ],
            "singular": [
                  "timme",
                  "timmes"
            ]
      },
      "minute": {
            "plural": [
                  "minuter",
                  "minuters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "månader",
                  "månaders"
            ],
            "singular": [
                  "månad",
                  "månads"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "års"
            ],
            "singular": [
                  "år",
                  "års"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
